import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getTreasuryBankAccounts } from '../treasuryAccountsEndpoints'
import { treasuryAccountKeys } from '../treasuryAccountsQueryKeys'
import {
  TREASURY_BANK_ACCOUNT_STATUS,
  type GetTreasuryBankAccountsParams,
} from '../../types/treasuryAccountsTypes'

/**
 * Shared-endpoint hook — the treasury bank accounts query backs the
 * approve dialogs in deposit / refund / withdraw, the picker in fiat
 * transactions, and the CRUD list in this module. Published from
 * treasury/treasuryAccounts/index.ts.
 */
export function useTreasuryBankAccountsQuery(
  params: MaybeRefOrGetter<GetTreasuryBankAccountsParams> = () => ({
    status: TREASURY_BANK_ACCOUNT_STATUS.ACTIVE,
  }),
) {
  return useQuery({
    queryKey: () => treasuryAccountKeys.list(toValue(params)),
    queryFn: () => getTreasuryBankAccounts(toValue(params)),
    staleTime: 1000 * 60,
  })
}
